import BigNumber from 'bignumber.js'
import { weiToEth, allTokensDict, logoPlaceHolder } from 'lottery/constants'
import { uriToHttp } from 'lottery/getTokenList'
import  humanFormat from'human-format'

export const formatValue = (value) => {
  if (value < 10) {
    return Math.round(value * 10000) / 10000
  } else {
    return humanFormat(value)
  }
}

export const getTokenMetaFromAddress = (address) =>
  allTokensDict[address.toLowerCase()]

export const getPoolTokenDecimal = (pool) =>
  getTokenMetaFromAddress(pool.token)?.decimals

export const getPoolTokenSymbol = (pool) =>
  getTokenMetaFromAddress(pool.token)?.symbol

export const getPoolRewardText = (pool) => {
  const rewardValue = formatValue(Number(weiToEth(BigNumber(pool.reward))))
  if (getTokenMetaFromAddress(pool.token)) {
    return `${rewardValue} ${getPoolTokenSymbol(pool)}`
  } else {
    return rewardValue
  }
}

export const getPoolBalanceText = (pool) => {
  if (getTokenMetaFromAddress(pool.token)) {
    return `${weiToEth(BigNumber(pool.balance)).toFixed(
      4
    )} ${getPoolTokenSymbol(pool)}`
  } else {
    return weiToEth(BigNumber(pool.balance)).toFixed(4)
  }
}

export const getPoolTokenLogoURL = (pool) => {
  const token = getTokenMetaFromAddress(pool.currencyToken)
  return token ? uriToHttp(token.logoURI)[0] : logoPlaceHolder
}

export const getTotalBonusTickets = (pool, purchaseSize) => {
  let weightBalance = weiToEth(BigNumber(pool.weightBalance))
  let bonus = 0
  for (let i = 0; i < purchaseSize; i++) {
    if (weightBalance > 0) {
      let _bonus = weightBalance / Number(pool.tickets)
      bonus += _bonus
      weightBalance = _bonus
    }
  }

  return bonus.toFixed(4)
}

export const getNextTicketBonus = (pool) =>
  (weiToEth(BigNumber(pool.weightBalance)) / pool.tickets).toFixed(4)

export const getTokenEtherFromWeiByAddress = (token, amount) =>
  BigNumber(10 ** token.decimals)
    .times(BigNumber(amount))
    .toFixed(0)

export const isUnnamed = (pool) =>
  pool && (pool.name === 'undefined' || pool.name === '')
